module.exports = __webpack_public_path__ + "videos/en_animate.961e4e5.mp4";